import * as Sentry from '@sentry/react'

import { config } from '../../config'

Sentry.init({
  dsn: config.sentry.dsn,
  release: config.sentry.release,
  debug: config.sentry.debug,
  environment: config.sentry.environment,
  integrations: [],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
})
